module.exports = __webpack_public_path__ + "img/deactivate.0bfa6e3f.svg";